import './sass/main.scss';
import './js/refs';
import './js/localeStorageServices';
import './js/galleryFetch';
import './js/openCloseModalFilm';
import './js/header-btn';
import './js/pagination';
import './js/teamModal';
import './js/scrollToTop';
import './js/togglerDayOrWeek';
import './js/library';
import './js/switchDayNight';
// import './js/themeSwitch'
